exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.active[data-v-654884e7]{color:black\n}\n", ""]);

// exports
